import { observer } from 'mobx-react-lite'
import { Box, Button } from 'shared/ui'
import { useRolesPermissionsContext } from 'pages/settings/pages/rolesPermissions/context/rolesPermissionsContextContext'

export const RolesPermissionsAction = observer(() => {
  const { loading, hasChangedPermissions, onCancel, onSave } = useRolesPermissionsContext()

  if (!hasChangedPermissions) return null

  return (
    <Box
      display={'flex'}
      justifyContent={'flex-end'}
      gap={'10px'}
      flex={'none'}
      paddingTop={'24px'}
      paddingBottom={'24px'}
      paddingRight={'20px'}
    >
      <Button
        text={'Cancel'}
        contained={'secondary'}
        size={'medium'}
        disabled={loading}
        onClick={onCancel}
      />
      <Button
        text={'Save'}
        contained={'primary'}
        loading={loading}
        size={'medium'}
        disabled={loading}
        onClick={onSave}
      />
    </Box>
  )
})
